import {
  REMOVE_VIDEO_FROM_COLLECTION,
  ADD_IN_VIDEO_COLLECTION,
  UPDATE_VIDEO_ACTIVE,
  SET_VIDEO_ACTIVE,
  MUTED_VIDEO,
  SAVE_MUTED_VIDEO,
  VIDEO_APPEND,
  VIDEO_REMOVE,
  RESET_VIDEOS_ACTION,
  RESET_VIDEOS,
  SET_PREV_POST_INDEX,
  SET_SCROLL_DIRECTION
} from '../actions/video'
import { isApp } from '@/utils/ReactNative'
import { _ } from 'vue-underscore'
// import { browserLog } from '../../helper/helper'
const getDefaultState = () => ({
  videoActiveId: null,
  videoCollection: [],
  muted: !isApp,
  scrollDirection: '',
  prevPostIndex: -1
})

const state = getDefaultState()

const getters = {
  getVideoCollection: state => state.videoCollection,
  getMuted: state => state.muted,
  getVideoActive: state => state.videoActiveId,
  getDirectionScroll: state => state.scrollDirection,
  getPrevPosIndex: state => state.prevPostIndex
}

const actions = {
  [UPDATE_VIDEO_ACTIVE]: ({ commit, state }) => {
    let videoCollectionValues = _.values(state.videoCollection)
    videoCollectionValues = _.filter(videoCollectionValues, elem => !!elem)
    const postID =
      state.scrollDirection === 'up' || window.scrollY < 10
        ? _.first(videoCollectionValues)
        : _.last(videoCollectionValues)

    if (state.videoActiveId !== postID) {
      commit('SET_VIDEO_ACTIVE', postID)
    }
  },
  [VIDEO_APPEND]: ({ commit, state, dispatch }, { id, index }) => {
    return new Promise((resolve, reject) => {
      const direction = state.prevPostIndex < index ? 'down' : 'up'
      commit(SET_SCROLL_DIRECTION, direction)
      commit(SET_PREV_POST_INDEX, index)
      commit(ADD_IN_VIDEO_COLLECTION, {id, index})
      dispatch(UPDATE_VIDEO_ACTIVE)
      resolve(true)
    })
  },
  [VIDEO_REMOVE]: ({ commit, state, dispatch }, { id }) => {
    // return new Promise((resolve, reject) => {
    commit(REMOVE_VIDEO_FROM_COLLECTION, id)
    dispatch(UPDATE_VIDEO_ACTIVE)

    // resolve(true)
    // })
  },
  [MUTED_VIDEO]: ({ commit }, status) => {
    return new Promise((resolve, reject) => {
      commit(SAVE_MUTED_VIDEO, status)
      resolve(status)
    })
  },
  [RESET_VIDEOS_ACTION]: ({ commit }) => {
    commit(RESET_VIDEOS)
  }
}

const mutations = {
  [SET_VIDEO_ACTIVE]: (state, id) => {
    state.videoActiveId = id
  },
  [SET_PREV_POST_INDEX]: (state, prevIndex) => {
    state.prevPostIndex = prevIndex
  },
  [SET_SCROLL_DIRECTION]: (state, scrollDirection) => {
    state.scrollDirection = scrollDirection
  },
  [REMOVE_VIDEO_FROM_COLLECTION]: (state, id) => {
    state.videoCollection = state.videoCollection.map(elem =>
      elem === id ? null : elem
    )
  },
  [ADD_IN_VIDEO_COLLECTION]: (state, {id, index}) => {
    let videosId = [...state.videoCollection]
    videosId[index] = id
    state.videoCollection = videosId
  },
  [SAVE_MUTED_VIDEO]: (state, status) => {
    state.muted = status
  },
  [RESET_VIDEOS]: state => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/video.js